import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
const content = $('.l-content');

export class Modal {
    isOpen = false;
    modal = '.js-modal';
    close = '.js-modal-close';
    wrapper = '.js-modal-wrapper';
    overlay = '.js-modal-overlay';
    focusableEls = [];

    openModal = () => {
        this.modalWrapper.fadeIn().css({'display': 'flex'});

        this.firstFocusableEl.focus();

        this.modalBody.on('keydown', this.handleKeyDown);
    }

    getFocusableElements = () => {
        const focusableEls = this.modalBody.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        this.focusableEls = Array.prototype.slice.call(focusableEls);
    }

    handleKeyDown = (event) => {
        const KEY_TAB = 9;
        const KEY_ESC = 27;
        switch (event.keyCode) {
            case KEY_TAB:
                if ( this.getFocusableElements.length === 1 ) {
                    event.preventDefault();
                    break;
                }
                if ( event.shiftKey ) {
                    this.handleBackwardTab(event);
                }else {
                    this.handleForwardTab(event);
                }
                break;
            case KEY_ESC:
                this.closeModal();
                break;
            default:
                break;
        }

    }
    handleBackwardTab = (e) => {
        if ( document.activeElement === this.firstFocusableEl ) {
            e.preventDefault();
            this.lastFocusableEl.focus();
        }
    }
    handleForwardTab = (e) => {
        if ( document.activeElement === this.lastFocusableEl ) {
            e.preventDefault();
            this.firstFocusableEl.focus();
        }
    }


    closeModal = () => {
        this.modalWrapper.fadeOut();

        this.modalBody.off('keydown', this.handleKeyDown);
    }

    constructor(node) {
        this.node = $(node);
        this.modalWrapper = $(this.wrapper);
        this.modalBody = $(this.modal);
        this.buttonClose = $(this.close);
        this.overlayEl = $(this.overlay);

        this.node.on('click', this.openModal);
        this.buttonClose.on('click', this.closeModal);
        this.overlayEl.on('click', this.closeModal);

        this.getFocusableElements();
        this.firstFocusableEl = $(this.focusableEls[0]).hasClass('js-modal-close') ? this.focusableEls[1] : this.focusableEls[0];
        this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    }
}



// WEBPACK FOOTER //
// ./app/scripts/shared/Modal.js